import React, { useState } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import DescriptionIcon from '@mui/icons-material/Description';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AdminPage from './AdminPage';
import AppShell from './AppShell';
import ClientPage from './ClientPage';
import Reports from './Reports';
import Notifications from './Notifications';
import Reminders from './Reminders';

/**
 * Role splitter. Admin → AdminPage (its own AppShell).
 * Client → AppShell with Anasayfa / Raporlar / Bildirimler / Hatırlatıcılar.
 */
const CLIENT_MENU = [
  { key: 0, label: 'Anasayfa',      icon: <HomeIcon /> },
  { key: 1, label: 'Raporlar',      icon: <DescriptionIcon /> },
  { key: 2, label: 'Bildirimler',   icon: <NotificationsIcon /> },
  { key: 3, label: 'Hatırlatıcılar', icon: <NotificationsActiveIcon /> },
];

function MainPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  const info = (() => {
    try { return JSON.parse(localStorage.getItem('companyInfo') || 'null'); }
    catch { return null; }
  })();

  if (info?.role === 'Admin') {
    return <AdminPage />;
  }

  const menuItems = CLIENT_MENU.map((m) => ({
    ...m,
    active: selectedTab === m.key,
    onClick: () => setSelectedTab(m.key),
  }));
  const title = CLIENT_MENU.find((m) => m.key === selectedTab)?.label || 'Peak Portal';

  return (
    <AppShell title={title} brand="Kullanıcı" menuItems={menuItems}>
      {selectedTab === 0 && <ClientPage />}
      {selectedTab === 1 && <Reports />}
      {selectedTab === 2 && <Notifications />}
      {selectedTab === 3 && <Reminders />}
    </AppShell>
  );
}

export default MainPage;
